import { render, staticRenderFns } from "./PncpBiddingFiles.vue?vue&type=template&id=c3ead518&"
import script from "./PncpBiddingFiles.vue?vue&type=script&lang=js&"
export * from "./PncpBiddingFiles.vue?vue&type=script&lang=js&"
import style0 from "./PncpBiddingFiles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports